import {get, post} from "./http_client";
import {api_vlog_comments_path} from "../routes";


export const query = vlog => get({ url: api_vlog_comments_path(vlog.id) })
export const create = (vlog, comment) => post({ url: api_vlog_comments_path(vlog.id), params: { comment } });